import { appSettings } from '@/settings/app-settings';

import createHttpClient from './http-client';

const httpClient = createHttpClient(appSettings.api.ASSET_MANAGER_URL || '');

export async function createDistribution(payload: any) {
  try {
    const response = await httpClient.post('/distribution-list/create', payload);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE CREATING DISTRIBUTION : ', error.message);
    throw error;
  }
}

export async function getDistributionList(params: { vendorId: string; search?: string }) {
  try {
    const response = await httpClient.get(`/distribution-list`, { params });
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE GETTING DISTRIBUTION LIST : ', error.message);
    throw error;
  }
}

export async function updateDistributionList(id: string, payload: any) {
  try {
    const response = await httpClient.put(`/distribution-list/${id}`, payload);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE UPDATE DISTRIBUTION : ', error.message);

    throw error;
  }
}

export async function deleteDistribution(id: string) {
  try {
    const response = await httpClient.delete(`/distribution-list/${id}`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE DELETE DISTRIBUTION : ', error.message);
    throw error;
  }
}

export async function getDistributionById(id: string) {
  try {
    const response = await httpClient.get(`/distribution-list/${id}`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE GEETING DISTRIBUTIONS BY ID : ', error.message);

    throw error;
  }
}

export async function subscribeDistribution(id: string) {
  try {
    const response = await httpClient.post(`/distribution-list/${id}/subscribe`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE SUBSCRIBING DISTRIBUTION: ', error.message);

    throw error;
  }
}

export async function unSubscribeDistribution(id: string) {
  try {
    const response = await httpClient.post(`/distribution-list/${id}/unsubscribe`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE UNSUBSCRIBING DISTRIBUTION: ', error.message);

    throw error;
  }
}

export async function getSubscriptionStatus(id: string) {
  try {
    const response = await httpClient.get(`/distribution-list/${id}/status`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE GETTING SUBSCRIPTION: ', error.message);

    throw error;
  }
}

export async function getSubscribedUsersByVendor(id: string, distributionListId?: string) {
  try {
    const response = await httpClient.get(`/distribution-list/vendor/${id}/subscribers`, {
      params: { distributionListId },
    });
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE GETTING SUBSCRIBERS BY VENDOR: ', error.message);

    throw error;
  }
}

export async function getLoggedInUserSubscriptions() {
  try {
    const response = await httpClient.get(`/distribution-list/my-subscriptions`);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE GETTING LOGGED IN USERS SUBSCRIPTIONS: ', error.message);

    throw error;
  }
}

export async function uploadDistributionUserCsvFile(formData: FormData) {
  const response = await httpClient.post(`/distribution-list/business/csv`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function markDistributionAsPrimary(payload: { distributionListId: string; vendorId: string }) {
  try {
    const response = await httpClient.post(`/distribution-list/mark-as-primary`, payload);
    return response.data;
  } catch (error: any) {
    console.log('ERROR WHILE MARKING DISTRIBUTION AS PRIMARY: ', error.message);
    throw error;
  }
}
